<template>
        <textarea
                :placeholder="placeholder"
                v-model="inputVal"
        ></textarea>
</template>


<script>

    export default {
        name: "uniTextArea",
        watch: {
          inputVal(val) {
              this.$emit('input', val)
          }
        },
        props: {
            placeholder: {
                type: String,
                default: '',
            },
            value: String
        },
        data() {
            return {
                inputVal: this.value
            }
        }
    }


</script>

<style scoped lang="scss">
    textarea {
        outline: none;
        border: 1px solid var(--color-grey-light-1);
        padding: 14px var(--s-xs);
        font-size: 1rem;
        line-height: 1rem;
        border-radius: var(--radius-default);
        width: 100%;
        transition: var(--transition-quick);
        display: block;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        background: none;
        color: var(--color-accent);

        &.invalid {
            border: 1px solid var(--color-warning);

            &:focus, &:hover {
                border: 1px solid var(--color-warning);
            }
        }

        &::placeholder {
            opacity: .5;
            color: var(--color-typo);
            font-size: 1rem;
            line-height: 1rem;
        }

        &:hover {
            border: 1px solid var(--color-primary-light-1);
        }

        &:focus {
            border: 1px solid var(--color-primary);
        }
    }

    span {
        color: var(--color-warning-dark);
    }


</style>
